import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["tokens", "size", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Divider.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var BaseDivider = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var tokens = _ref.tokens,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "small" : _ref$size,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx(views.Divider, _objectSpread(_objectSpread({
    ref: ref
  }, tokens), {}, {
    size: size,
    className: className
  }, rest));
});
export var Divider = withDesignTokens(BaseDivider, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.boysenberry[200]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[20]
    };
  }
});
export default Divider;